<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">
      {{ $t("buyNowPayLater.authorizedUsers") }}
      &nbsp;&nbsp;
      <button
        class="button is-small"
        @click="isNewBuyNowPayLaterUserModalActive = true"
        style="position: relative; bottom: 2px"
      >
        <b-icon icon="plus-circle" type="is-primary"></b-icon>
      </button>
    </h2>

    <p v-if="!buyNowPayLaterUsers || buyNowPayLaterUsers.length === 0">
      {{ $t("buyNowPayLater.noUsersAtThisMoment") }}
    </p>

    <b-table v-else :data="buyNowPayLaterUsers" hoverable :key="tableKey">
      <b-table-column field="name" label="Nome" v-slot="props">
        {{ `${props.row.personalInfo.name} ${props.row.personalInfo.surname}` }}
      </b-table-column>

      <b-table-column field="name" label="Nome" v-slot="props">
        {{ props.row.personalInfo.email }}
      </b-table-column>

      <b-table-column :label="$t('common.delete')" v-slot="props">
        <button
          class="button is-small"
          @click="confirmBuyNowPayLaterUserDeletion(props.row)"
        >
          <b-icon icon="minus-circle" type="is-primary"></b-icon>
        </button>
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>
    </b-table>

    <b-modal :active.sync="isNewBuyNowPayLaterUserModalActive">
      <new-buy-now-pay-later-user-modal @increment-key="tableKey++" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import newBuyNowPayLaterUserModal from "./NewBuyNowPayLaterUserModal";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      isNewBuyNowPayLaterUserModalActive: false,
      tableKey: 0
    };
  },

  components: {
    newBuyNowPayLaterUserModal,
    tableEmptyTemplate
  },

  methods: {
    confirmBuyNowPayLaterUserDeletion(user) {
      this.$buefy.dialog.confirm({
        message: this.$t("buyNowPayLater.confirmBuyNowPayLaterUserDeletion"),
        cancelText: this.$t("common.cancel"),
        confirmText: this.$t("common.yes"),
        onConfirm: () => this.removeBuyNowPayLaterUser(user)
      });
    },

    removeBuyNowPayLaterUser(user) {
      this.isLoading = true;
      this.$store
        .dispatch("removeBuyNowPayLaterUser", {
          storeId: this.storeBeingManaged._id,
          userId: user._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              duration: 3000,
              message: this.$t("buyNowPayLater.userDeleted"),
              position: "is-bottom",
              type: "is-primary"
            });
            this.tableKey++;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged"]),

    buyNowPayLaterUsers() {
      return (
        (this.storeBeingManaged &&
          this.storeBeingManaged.payments &&
          this.storeBeingManaged.payments.buyNowPayLater &&
          this.storeBeingManaged.payments.buyNowPayLater.users) ||
        []
      );
    }
  }
};
</script>

<style scoped>
.cashback-switch {
  position: relative;
  top: 2px;
  left: 6px;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
</style>
